"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.billingAccountAddressListIdsMatch = exports.billingAccountAddressTextMatches = exports.extractBillingAccountAddressFields = exports.normalizeAddressTextForCompare = void 0;
/**
 * Normalizes billing/shipping address display text for comparison (vendor-bill style).
 * Strips newlines, punctuation, and spaces; lowercases alphanumerics only.
 */
function normalizeAddressTextForCompare(raw) {
    return String(raw ?? "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
}
exports.normalizeAddressTextForCompare = normalizeAddressTextForCompare;
/** Extract list ids and display text from GET /billingaccount/{id} payload. */
function extractBillingAccountAddressFields(ba) {
    const listId = (v) => {
        if (v === null || v === undefined) {
            return "";
        }
        if (typeof v === "object" && v.id != null) {
            return String(v.id).trim();
        }
        return String(v).trim();
    };
    const text = (v) => {
        if (v === null || v === undefined) {
            return "";
        }
        return String(v).trim();
    };
    return {
        shipAddressListId: listId(ba?.shipAddressList ?? ba?.shipaddresslist ?? ba?.shipAddressList?.id),
        billAddressListId: listId(ba?.billAddressList ?? ba?.billaddresslist ?? ba?.billAddressList?.id),
        shipAddressText: text(ba?.shipAddress ?? ba?.shipaddress),
        billAddressText: text(ba?.billAddress ?? ba?.billaddress),
    };
}
exports.extractBillingAccountAddressFields = extractBillingAccountAddressFields;
function billingAccountAddressTextMatches(oldText, newText) {
    const a = normalizeAddressTextForCompare(oldText);
    const b = normalizeAddressTextForCompare(newText);
    return Boolean(a) && a === b;
}
exports.billingAccountAddressTextMatches = billingAccountAddressTextMatches;
function billingAccountAddressListIdsMatch(oldId, newId) {
    const a = String(oldId ?? "").trim();
    const b = String(newId ?? "").trim();
    return Boolean(a) && a === b;
}
exports.billingAccountAddressListIdsMatch = billingAccountAddressListIdsMatch;
